export default __webpack_public_path__ + "static/west-brom-logo-fd6c21138d46630e690e64d9cb3c2557.svg";